import React from "react";
import ContractFarming from "../../assets/images/contract-farming.jpg";
import ManageEcobee from "../../assets/images/manage-eco-bee.jpg"
import AboutSectionSubsection1 from "../../components/AboutSection1/AboutSectionSubsection1";
function ProfitGeneratingServices() {
  const serviceData = [
    {
      title: "Monetize contract farming capacity",
      description:
        "ApisChain's Monetize Contract Farming Capacity service is a pivotal offering, enabling eco-entrepreneurs to produce honey and related products for third party (agri-investor). This innovative approach empowers them to sell produce in advance while promoting sustainable farming practices.",
      image: ContractFarming,
    },

    {
      title: "Monetize farming capacity by managing Eco-Bee",
      description:
        " ApisChain offers eco-entrepreneurs a unique service that monetizes farming capacity by managing the assets of other investors and eco-contributors. This profit-generating model allows entrepreneurs to leverage available resources and maximize returns, while ApisChain handles the operational aspects, ensuring efficiency and profitability.          ",
      image: ManageEcobee,
      rowreverse: "true",
    },
  ];
  return (
    <>
      <div className="container">
        {serviceData.map((data, index) => {
          return (
            <AboutSectionSubsection1
              key={index}
              src={data.image}
              bodycopy={data.description}
              title={data.title}
              rowreverse={data.rowreverse}
            />
          );
        })}
      </div>
    </>
  );
}

export default ProfitGeneratingServices;
